import Colors from "@constants/Colors";
import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const StyledRootBox = styled(Box)`
  display: flex;
  padding: 16px;
  flex-direction: column;
  background: ${Colors.white};
  border: 1px solid ${Colors.neutral_gray_300};
  box-shadow: ${Colors.Elevation_2};
  border-radius: 12px;
  min-height: 407px !important;
`;

export const StyledRowBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  padding: 0px !important;
}
`;

export const StyledLabourRow = styled(Box)`
  display: flex !important;
  gap: 16px;
  padding: 8px 0px !important;
`;

export const StyledRow = styled(Box)`
  display: flex !important;
  gap: 6px;
  justify-content: space-between !important;
  padding: 8px 0px !important;
`;

export const StyledTypographySales = styled(Typography)<{ background: string }>`
  width: fit-content !important;
  border-radius: 4px !important;
  padding: ${({ background }: { background: string }) =>
    background.length > 0 ? "0px 8px" : "0px"} !important;
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.neutralblack};
`;

export const StyledRowTypography = styled(Typography)`
  font-family: "Ringside Regular-Book" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.neutral_gray_500};
`;

export const StyledLineChartBox = styled(Box)`
  padding: 8px 0px !important;
`;

export const StyledBox = styled(Box)`
  padding-top: 20px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
